import { type FC, useMemo } from 'react';

import { hasTiptapContent } from '@shared/dream-components';
import type { JSONContent } from '@tiptap/core';
import cn from 'classnames';

import { splitTrailingMedia } from '~/routes/community/_utils/splitTrailingMedia';

import { ReadMoreClamp } from './ui/ReadMoreClamp';

import { TiptapRenderer } from './TiptapRenderer';
import { TrailingMedia } from './TrailingMedia';

interface PostBodyProps {
  tiptapState: JSONContent;
  postId: string;
  // Feed surfaces clamp the text behind read more; the post page shows it in full.
  clampText?: boolean;
  className?: string;
}

export const PostBody: FC<PostBodyProps> = ({ tiptapState, postId, clampText = false, className }) => {
  const { body, trailingMedia } = useMemo(() => splitTrailingMedia(tiptapState), [tiptapState]);
  const hasBody = hasTiptapContent(body);
  const hasTrailingMedia = trailingMedia.length > 0;

  if (!hasBody && !hasTrailingMedia) return null;

  const text = hasBody && <TiptapRenderer tiptapState={body} postId={postId} zoomableImages />;

  return (
    <div className={cn('flex flex-col gap-4', className)}>
      {clampText && hasBody ? <ReadMoreClamp>{text}</ReadMoreClamp> : text}
      {hasTrailingMedia && <TrailingMedia nodes={trailingMedia} postId={postId} />}
    </div>
  );
};
